export default __webpack_public_path__ + "i18n/translation-es.13d8c5df.json";